import * as THREE from 'three';

class CameraEnginePlayerPlace {
	
	camera: THREE.PerspectiveCamera;
	
	constructor(scene: THREE.Scene, canvas: any) {
		//

		this.camera = new THREE.PerspectiveCamera( 90, window.innerWidth / window.innerHeight, 0.01, 1500 );
		
		this.camera.position.set(3, 2.5, 0);
		
		
		
		this.camera.lookAt(500, 10, 0);
		
		scene.add(this.camera);
		
		
		
		
	}
	/////////////////////////////////////////////////////////
	animate() {
//		this.controls.update();
	}
	/////////////////////////////////////////////////////////
	getCamera() {
		return this.camera;
	}
	/////////////////////////////////////////////////////////
	
}
export default CameraEnginePlayerPlace;